import { cartStore } from "@gob/cart-store";

const selectors = {
  data: '[data-cart-line-json]',
  removeButton: '[data-remove-button]',
  quantityInput: '[name="quantity"]',
  quantityButton: '[data-quantity-button]',
}

class ComponentCartLine extends HTMLElement {
  constructor() {
    super();

    this.handleRemoveButtonClick = this.handleRemoveButtonClick.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.handleQuantityButtonClick = this.handleQuantityButtonClick.bind(this);
  }

  handleRemoveButtonClick() {
    if (!this.index) return;

    cartStore.removeItem(this.index);
  }

  handleQuantityChange(line, quantity) {
    if (!line || typeof quantity !== 'number') return;

    cartStore.updateQuantity(line, quantity);
  }

  handleQuantityButtonClick(event) {
    const action = event.currentTarget.dataset.action;
    const currentQuantity = this.quantityInput.value;

    this.quantityButtons.forEach(button => {
      button.setAttribute('disabled', true);
    });

    this.setAttribute('data-loading', true);

    if (action === 'decrease') {
      const newQuantity = parseInt(currentQuantity) - 1;
      this.quantityInput.value = newQuantity;
      this.handleQuantityChange(this.index, newQuantity);
    } else if (action === 'increase') {
      const newQuantity = parseInt(currentQuantity) + 1;
      this.quantityInput.value = newQuantity;
      this.handleQuantityChange(this.index, newQuantity);
    }
  }

  connectedCallback() {
    this.data = JSON.parse(this.querySelector(selectors.data).textContent);
    this.removeButton = this.querySelector(selectors.removeButton);
    this.quantityInput = this.querySelector(selectors.quantityInput);
    this.quantityButtons = this.querySelectorAll(selectors.quantityButton);
    this.index = this.getAttribute('data-index');

    this.removeButton.addEventListener('click', this.handleRemoveButtonClick);
    this.quantityButtons.forEach(button => {
      button.addEventListener('click', this.handleQuantityButtonClick);
    });
  }
}

if (!customElements.get('cart-line')) {
  customElements.define('cart-line', ComponentCartLine);
}